<div class="fxed020_menu_container">
  <div class="fx_shop_toolbar_main">
    <p>{{'fxed020-所有商品品类' | translate}}</p><i class="fx_down"></i>
  </div>

  <div class="fx_shop_toolbar_list">
    <ul>
      <li *ngFor="let item of listData;let i = index;" [routerLink]="['./info']" [queryParams]="{id:item.id}">
        <div class="categroy-group">
          <img src="{{item.caa010}}" alt="">
          <span>{{item.new_name}}</span>
        </div>
      </li>
    </ul>

  </div>
</div>
